import { logoColor } from "./Logo";

export default function LogoWithText({
  size = 20,
  style,
  onClick,
}: {
  size?: number;
  style?: React.CSSProperties;
  onClick?: () => void;
}): React.ReactElement {
  return (
    <svg
      height={size}
      onClick={onClick}
      style={style}
      viewBox="0 0 102 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="20" height="20" rx="6" fill={logoColor} />
      <rect
        x="4.58057"
        y="15.4192"
        width="15.7583"
        height="0.9375"
        rx="0.46875"
        transform="rotate(-45 4.58057 15.4192)"
        fill="white"
      />
      <rect
        x="11.0205"
        y="15.5327"
        width="6.71895"
        height="0.9375"
        rx="0.46875"
        transform="rotate(-45 11.0205 15.5327)"
        fill="white"
      />
      <rect
        x="4.375"
        y="6.875"
        width="2.5"
        height="2.5"
        rx="1.25"
        transform="rotate(-90 4.375 6.875)"
        fill="white"
      />
      <path
        d="M29.162 15V4.794H31.458V8.854H35.686V4.794H37.968V15H35.686V10.8H31.458V15H29.162ZM39.6749 17.338V15.658H42.3349V14.188L39.3669 7.482H41.6069L43.1189 11.528L43.3429 12.242H43.4269L43.6509 11.528L45.2049 7.482H47.4449L44.4769 14.188V15.966C44.4769 16.904 43.9029 17.338 43.0349 17.338H39.6749ZM48.6538 17.338V7.482H50.6978L50.8098 8.588H50.9078C51.2718 7.804 52.1258 7.342 53.1198 7.342C55.1358 7.342 56.0038 8.812 56.0038 11.094V11.416C56.0038 14.02 54.8838 15.14 53.1198 15.14C52.1398 15.14 51.2858 14.678 50.9078 13.894H50.8098V17.338H48.6538ZM52.2518 13.39C53.1758 13.39 53.7078 12.844 53.7078 11.892V10.604C53.7078 9.652 53.1758 9.092 52.2518 9.092C51.3698 9.092 50.8238 9.666 50.8238 10.632V11.864C50.8238 12.83 51.3698 13.39 52.2518 13.39ZM60.6925 15.14C58.1865 15.14 56.9685 13.586 56.9685 11.262V11.136C56.9685 8.7 58.4105 7.342 60.5245 7.342C62.8205 7.342 64.1225 8.742 64.1225 10.828V11.78H59.1525V12.172C59.1525 12.984 59.7545 13.502 60.6225 13.502C61.3925 13.502 61.9105 13.138 62.0085 12.578H64.0385C63.9545 14.104 62.5965 15.14 60.6925 15.14ZM59.1525 10.38V10.45H62.0085V10.38C62.0085 9.372 61.4345 8.938 60.5945 8.938C59.6985 8.938 59.1525 9.456 59.1525 10.38ZM72.9016 15C71.6976 15 71.2356 14.328 71.2356 13.334V5.13H73.3916V7.482H75.2536V9.218H73.3916V13.32H75.1556V15H72.9016ZM65.5796 15V9.148C65.5796 8.126 66.2516 7.482 67.2456 7.482H70.3116V9.218H67.7356V15H65.5796ZM79.1439 15.14C77.4779 15.14 76.6659 13.95 76.6659 12.158V7.482H78.8079V11.85C78.8079 13.04 79.3259 13.404 80.1239 13.404C81.0759 13.404 81.5659 12.718 81.5659 11.682V7.482H83.7079V15H81.7059L81.5519 13.768H81.4399C81.1039 14.594 80.2499 15.14 79.1439 15.14ZM85.5952 15V7.482H87.5972L87.7512 8.714H87.8772C88.1992 7.888 89.0252 7.342 90.1032 7.342C91.7132 7.342 92.7072 8.28 92.7072 10.394V15H90.5652V10.674C90.5652 9.47 90.0332 9.092 89.2212 9.092C88.2412 9.092 87.7512 9.778 87.7512 10.828V15H85.5952ZM97.8253 15.14C95.3193 15.14 94.1013 13.586 94.1013 11.262V11.136C94.1013 8.7 95.5433 7.342 97.6573 7.342C99.9533 7.342 101.255 8.742 101.255 10.828V11.78H96.2853V12.172C96.2853 12.984 96.8873 13.502 97.7553 13.502C98.5253 13.502 99.0433 13.138 99.1413 12.578H101.171C101.087 14.104 99.7293 15.14 97.8253 15.14ZM96.2853 10.38V10.45H99.1413V10.38C99.1413 9.372 98.5673 8.938 97.7273 8.938C96.8313 8.938 96.2853 9.456 96.2853 10.38Z"
        fill={logoColor}
      />
    </svg>
  );
}
